/* =============================================================
   KLEURVERKENNER PETTERNS  v1.2
   =============================================================
   PDP-widget die 50 kleurvarianten toont. Bezoekers kiezen een
   kleur, uitvoering (inliggend / opliggend / twin) en muurkleur
   en kunnen direct bestellen vanuit de modal.

   ── PLAATSING ───────────────────────────────────────────────
   In sections/product-template.liquid (of main-product.liquid):

     {% render 'kleurverkenner' %}
       Verplicht, eenmalig. Plaatst de trigger-knop en laadt de
       widget-data (product handle + titel).

     {% render 'kleurverkenner-knop' %}
       Optioneel, herhaalbaar. Extra knop op elke gewenste plek.
       Ondersteunt een `tekst`-parameter:
         {% render 'kleurverkenner-knop', tekst: 'Andere kleur' %}

   ── VEREISTE ASSETS IN THEME.LIQUID ────────────────────────
     <head>  : {{ 'kleurverkenner.css' | asset_url | stylesheet_tag }}
     </body> : {{ 'kleurverkenner.js'  | asset_url | script_tag }}

   ── EEN NIEUW DESIGN TOEVOEGEN ──────────────────────────────
   Voeg de product-handle toe aan FORMAT_MAP (zie hieronder) met
   het juiste formaat: 'vierkant' | 'rechthoek' | 'langwerpig'.
   Zorg dat de bijbehorende kleurafbeeldingen op de CDN staan:
     kh-kleur-{formaat}-{handle}-{inliggend|opliggend}-{code}.jpg

   ── KINDERLIJN ──────────────────────────────────────────────
   De kinderlijn-designs (KIDS_HANDLES) wijken af van de rest:
     - één maat (60×90 cm), geen maatkeuze
     - geen twin-variant
     - Shopify-varianten: option1 = 'Kleurnaam (code)',
       option2 = 'Inliggend'|'Opliggend' (geen maat-optie)
     - elke kleur is een gewone variant — geen GPO line-item
       property en geen maatwerk-melding

   ── GOOGLE ANALYTICS 4 EVENTS ───────────────────────────────
   Events worden automatisch verstuurd via window.gtag() zodra
   GA4 op de site staat. Geen extra configuratie nodig.

   Event              Parameters
   ─────────────────  ─────────────────────────────────────────
   kv_modal_open      kv_product
   kv_kleur_select    kv_product · kv_kleur (code) · kv_naam
   kv_modus_select    kv_product · kv_modus
   kv_muurkleur_select kv_product · kv_muurkleur (hex)
   kv_bestel_open     kv_product · kv_kleur · kv_modus
   kv_maat_select     kv_product · kv_maat
   kv_add_to_cart     kv_product · kv_kleur · kv_maat · kv_modus
   kv_besteld         kv_product · kv_kleur · kv_maat · kv_modus

   Alle parameters hebben het prefix kv_ om conflicten met andere
   GA4-parameters op de site te vermijden.

   Om parameters zichtbaar te maken in GA4:
     Admin → Custom definitions → Custom dimensions → aanmaken
     per parameter (kv_kleur, kv_maat, kv_modus, kv_product).
     Scope: Event.

   Om kv_besteld als conversie te markeren:
     Admin → Events → kv_besteld → toggle "Mark as conversion".

   ── SHOPIFY CART-INTEGRATIE ─────────────────────────────────
   Na een succesvolle add-to-cart wordt het custom event
   'ajaxProduct:added' gegooid. Het Petterns-theme luistert
   hierop in CartDrawer en opent de winkelmand automatisch.

   ── BROWSER-ONDERSTEUNING ───────────────────────────────────
   Geschreven in ES5 (geen transpiler nodig). Werkt in alle
   moderne browsers. fetch() vereist (IE niet ondersteund).
   ============================================================= */

(function () {
  'use strict';

  /* ---------------------------------------------------------
     CONSTANTEN — CDN-paden
  --------------------------------------------------------- */

  var CDN       = 'https://cdn.shopify.com/s/files/1/0835/2838/4847/t/5/assets/';
  var CDN_KLEUR = 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/';

  /* ---------------------------------------------------------
     FORMAT_MAP — product-handle → beeldformaat
     Bepaalt welke afmetingen en afbeeldingsnamen gelden.
  --------------------------------------------------------- */

  var FORMAT_MAP = {
    wave:'vierkant', flexible:'vierkant', placetobe:'vierkant',
    spinning:'vierkant', cow:'vierkant', splash:'vierkant', moonie:'vierkant',
    plants:'rechthoek', leaves:'rechthoek', organic:'rechthoek',
    party:'rechthoek', people:'rechthoek', rainbow:'rechthoek', liv:'rechthoek',
    swirl:'langwerpig', steam:'langwerpig', eye:'langwerpig',
    zeb:'langwerpig', lava:'langwerpig', bone:'langwerpig',
    hieroglyph:'langwerpig',
    hommel:'rechthoek', kevers:'rechthoek', krab:'rechthoek',
    luiaard:'rechthoek', schildpad:'rechthoek', toekan:'rechthoek'
  };

  /* ---------------------------------------------------------
     KINDERLIJN — één maat (60×90), geen twin, varianten op
     Kleur × Type i.p.v. Kleur × Maat × Type.
  --------------------------------------------------------- */

  var KIDS_HANDLES = ['hommel', 'kevers', 'krab', 'luiaard', 'schildpad', 'toekan'];
  var KIDS_MAAT    = '60\u00d790 cm';

  function isKids() {
    return KIDS_HANDLES.indexOf(state.handle) !== -1;
  }

  /* ---------------------------------------------------------
     KLEUREN — 50 kleurvarianten
     variantKleur : Shopify option1 ('Zand' of 'Gebroken wit')
     gpoWaarde    : waarde van line-item property 'Maatwerk kleur'
                    (null = standaard kleur, geen GPO vereist)
  --------------------------------------------------------- */

  var KLEUREN_VOLGORDE = [
    '20','88','32','06','124_NL','146_NL','12','17','40','133_NL',
    '16','23','03','105_NL','09','108_NL','482_NL','38','01','284_NL',
    '280_NL','27','14','57','368_NL','372_NL','388_NL','19','26','43',
    '51','48','05','553_NL','83','65','39','22','58','435_NL',
    '421_NL','13','56','582_NL','546_NL','25','24','41','463_NL','53'
  ];

  var KLEUREN = {
    '01':     { naam:'Dark Blue',    img:CDN+'kh-swatch-01.jpg',     gpoWaarde:'Dark Blue (01)',         variantKleur:'Zand' },
    '03':     { naam:'Antraciet',    img:CDN+'kh-swatch-03.jpg',     gpoWaarde:'Antraciet (03)',         variantKleur:'Zand' },
    '05':     { naam:'Yellow',       img:CDN+'kh-swatch-05.jpg',     gpoWaarde:'Yellow (05)',            variantKleur:'Zand' },
    '06':     { naam:'Vanille',      img:CDN+'kh-swatch-06.jpg',     gpoWaarde:'Vanille (06)',           variantKleur:'Zand' },
    '09':     { naam:'Black',        img:CDN+'kh-swatch-09.jpg',     gpoWaarde:'Black (09)',             variantKleur:'Zand' },
    '12':     { naam:'Silver Grey',  img:CDN+'kh-swatch-12.jpg',     gpoWaarde:'Silver Grey (12)',       variantKleur:'Zand' },
    '13':     { naam:'Terra',        img:CDN+'kh-swatch-13.jpg',     gpoWaarde:'Terra (13)',             variantKleur:'Zand' },
    '14':     { naam:'Light Blue',   img:CDN+'kh-swatch-14.jpg',     gpoWaarde:'Light Blue (14)',        variantKleur:'Zand' },
    '16':     { naam:'Grey',         img:CDN+'kh-swatch-16.jpg',     gpoWaarde:'Grey (16)',              variantKleur:'Zand' },
    '17':     { naam:'Blush',        img:CDN+'kh-swatch-17.jpg',     gpoWaarde:'Blush (17)',             variantKleur:'Zand' },
    '19':     { naam:'Green',        img:CDN+'kh-swatch-19.jpg',     gpoWaarde:'Green (19)',             variantKleur:'Zand' },
    '20':     { naam:'White',        img:CDN+'kh-swatch-20.jpg',     gpoWaarde:'White (20)',             variantKleur:'Zand' },
    '22':     { naam:'Dark Camel',   img:CDN+'kh-swatch-22.jpg',     gpoWaarde:'Dark Camel (22)',        variantKleur:'Zand' },
    '23':     { naam:'Dark Grey',    img:CDN+'kh-swatch-23.jpg',     gpoWaarde:'Dark Grey (23)',         variantKleur:'Zand' },
    '24':     { naam:'Cherry',       img:CDN+'kh-swatch-24.jpg',     gpoWaarde:'Cherry (24)',            variantKleur:'Zand' },
    '25':     { naam:'Red',          img:CDN+'kh-swatch-25.jpg',     gpoWaarde:'Red (25)',               variantKleur:'Zand' },
    '26':     { naam:'Dark Green',   img:CDN+'kh-swatch-26.jpg',     gpoWaarde:'Dark Green (26)',        variantKleur:'Zand' },
    '27':     { naam:'Middle Blue',  img:CDN+'kh-swatch-27.jpg',     gpoWaarde:'Middle Blue (27)',       variantKleur:'Zand' },
    '32':     { naam:'Off White',    img:CDN+'kh-swatch-32.jpg',     gpoWaarde:null,                     variantKleur:'Gebroken wit' },
    '38':     { naam:'Midnight Blue',img:CDN+'kh-swatch-38.jpg',     gpoWaarde:'Midnight Blue (38)',     variantKleur:'Zand' },
    '39':     { naam:'Light Oak',    img:CDN+'kh-swatch-39.jpg',     gpoWaarde:'Light Oak (39)',         variantKleur:'Zand' },
    '40':     { naam:'Cool Grey',    img:CDN+'kh-swatch-40.jpg',     gpoWaarde:'Cool Grey (40)',         variantKleur:'Zand' },
    '41':     { naam:'Purple',       img:CDN+'kh-swatch-41.jpg',     gpoWaarde:'Purple (41)',            variantKleur:'Zand' },
    '43':     { naam:'Lime',         img:CDN+'kh-swatch-43.jpg',     gpoWaarde:'Lime (43)',              variantKleur:'Zand' },
    '48':     { naam:'Olive',        img:CDN+'kh-swatch-48.jpg',     gpoWaarde:'Olive (48)',             variantKleur:'Zand' },
    '51':     { naam:'Apple Green',  img:CDN+'kh-swatch-51.jpg',     gpoWaarde:'Apple Green (51)',       variantKleur:'Zand' },
    '53':     { naam:'Brown',        img:CDN+'kh-swatch-53.jpg',     gpoWaarde:'Brown (53)',             variantKleur:'Zand' },
    '56':     { naam:'Orange',       img:CDN+'kh-swatch-56.jpg',     gpoWaarde:'Orange (56)',            variantKleur:'Zand' },
    '57':     { naam:'Petrol',       img:CDN+'kh-swatch-57.jpg',     gpoWaarde:'Petrol (57)',            variantKleur:'Zand' },
    '58':     { naam:'Light Camel',  img:CDN+'kh-swatch-58.jpg',     gpoWaarde:'Light Camel (58)',       variantKleur:'Zand' },
    '65':     { naam:'Copper',       img:CDN+'kh-swatch-65.jpg',     gpoWaarde:'Copper (65)',            variantKleur:'Zand' },
    '83':     { naam:'Gold',         img:CDN+'kh-swatch-83.jpg',     gpoWaarde:'Gold (83)',              variantKleur:'Zand' },
    '88':     { naam:'Snow',         img:CDN+'kh-swatch-88.jpg',     gpoWaarde:'Snow (88)',              variantKleur:'Zand' },
    '105_NL': { naam:'Antraciet',    img:CDN+'kh-swatch-105_NL.jpg', gpoWaarde:'Antraciet (105_NL)',     variantKleur:'Zand' },
    '108_NL': { naam:'Zwart',        img:CDN+'kh-swatch-108_NL.jpg', gpoWaarde:'Zwart (108_NL)',         variantKleur:'Zand' },
    '124_NL': { naam:'Madelief Wit', img:CDN+'kh-swatch-124_NL.jpg', gpoWaarde:'Madelief wit (124_NL)',  variantKleur:'Zand' },
    '133_NL': { naam:'Beton Grijs',  img:CDN+'kh-swatch-133_NL.jpg', gpoWaarde:'Beton Grijs (133_NL)',   variantKleur:'Zand' },
    '146_NL': { naam:'Marmer',       img:CDN+'kh-swatch-146_NL.jpg', gpoWaarde:'Marmer (146_NL)',        variantKleur:'Zand' },
    '280_NL': { naam:'Staal Blauw',  img:CDN+'kh-swatch-280_NL.jpg', gpoWaarde:'Staal Blauw (280_NL)',   variantKleur:'Zand' },
    '284_NL': { naam:'Marine Blauw', img:CDN+'kh-swatch-284_NL.jpg', gpoWaarde:'Marine Blauw (284_NL)',  variantKleur:'Zand' },
    '368_NL': { naam:'Smaragd',      img:CDN+'kh-swatch-368_NL.jpg', gpoWaarde:'Smaragd (368_NL)',       variantKleur:'Zand' },
    '372_NL': { naam:'Eucalyptus',   img:CDN+'kh-swatch-372_NL.jpg', gpoWaarde:'Eucalyptus (372_NL)',    variantKleur:'Zand' },
    '388_NL': { naam:'Zeegroen',     img:CDN+'kh-swatch-388_NL.jpg', gpoWaarde:'Zeegroen (388_NL)',      variantKleur:'Zand' },
    '421_NL': { naam:'Muskaat',      img:CDN+'kh-swatch-421_NL.jpg', gpoWaarde:'Muskaat (421_NL)',       variantKleur:'Zand' },
    '435_NL': { naam:'Zand',         img:CDN+'kh-swatch-435_NL.jpg', gpoWaarde:null,                     variantKleur:'Zand' },
    '463_NL': { naam:'Turf',         img:CDN+'kh-swatch-463_NL.jpg', gpoWaarde:'Turf (463_NL)',          variantKleur:'Zand' },
    '482_NL': { naam:'Bastard',      img:CDN+'kh-swatch-482_NL.jpg', gpoWaarde:'Bastard (482_NL)',       variantKleur:'Zand' },
    '546_NL': { naam:'Koraal Rood',  img:CDN+'kh-swatch-546_NL.jpg', gpoWaarde:'Koraal Rood (546_NL)',   variantKleur:'Zand' },
    '553_NL': { naam:'Mosterd',      img:CDN+'kh-swatch-553_NL.jpg', gpoWaarde:'Mosterd (553_NL)',       variantKleur:'Zand' },
    '582_NL': { naam:'Pompoen',      img:CDN+'kh-swatch-582_NL.jpg', gpoWaarde:'Pompoen (582_NL)',       variantKleur:'Zand' }
  };

  /* ---------------------------------------------------------
     MUURKLEUREN — preset-swatches in de header
     Desktop: alle 7 zichtbaar.
     Mobiel:  CSS verbergt preset 6 & 7 (.kv-preset:nth-child(n+6))
              zodat er 5 presets + kleurpicker = 6 items zijn.
  --------------------------------------------------------- */

  var MUURKLEUREN_PRESETS = [
    { naam:'Wit',         hex:'#FFFFFF' },
    { naam:'Warm wit',    hex:'#F5F0E8' },
    { naam:'Zandbeige',   hex:'#E0D6C6' },
    { naam:'Lichtgrijs',  hex:'#D4D4D4' },
    { naam:'Leisteen',    hex:'#6B7280' },
    { naam:'Donkerblauw', hex:'#1E2D4A' },
    { naam:'Antraciet',   hex:'#2E2E2E' }
  ];

  /* ---------------------------------------------------------
     AFMETINGEN — per formaat, gebruikt voor de bestelknop.
     Prijzen worden live opgehaald via /products/{handle}.js.
  --------------------------------------------------------- */

  var AFMETINGEN = {
    vierkant:  [
      { maat:'40\u00d740 cm',   naam:'Subtiel'    },
      { maat:'60\u00d760 cm',   naam:'Opvallend'  },
      { maat:'80\u00d780 cm',   naam:'Blikvanger' },
      { maat:'120\u00d7120 cm', naam:'Eyecatcher' }
    ],
    rechthoek: [
      { maat:'40\u00d760 cm',   naam:'Subtiel'    },
      { maat:'60\u00d790 cm',   naam:'Opvallend'  },
      { maat:'80\u00d7120 cm',  naam:'Blikvanger' },
      { maat:'120\u00d7180 cm', naam:'Eyecatcher' }
    ],
    langwerpig: [
      { maat:'40\u00d780 cm',   naam:'Subtiel'    },
      { maat:'60\u00d7120 cm',  naam:'Opvallend'  },
      { maat:'80\u00d7160 cm',  naam:'Blikvanger' },
      { maat:'120\u00d7240 cm', naam:'Eyecatcher' }
    ]
  };

  /* Shopify option3-waarden per modus */
  var TYPE_SHOPIFY = {
    inliggend: 'Inliggend',
    opliggend:  'Opliggend',
    twin:       'Twin (Set inliggend \u00e9n opliggend)'
  };

  /* ---------------------------------------------------------
     STATE — enige bron van waarheid
  --------------------------------------------------------- */

  var state = {
    handle:      '',
    titel:       '',
    format:      'vierkant',
    kleur:       '20',
    modus:       'inliggend',
    muurkleur:   '#F5F0E8',
    maat:        null,
    variantId:   null,
    productData: null   // gecached na eerste fetch
  };

  /* Defer het laden van de eerste afbeelding tot de modal opent */
  var eersteBeeldLaad = true;
  var modalOpen       = false;

  /* Gecachede DOM-refs (gevuld in init) */
  var elViewer, elBeeldArea, elLoader, elTooltip;

  /* ---------------------------------------------------------
     HELPERS
  --------------------------------------------------------- */

  /* Afbeeldings-URL: kh-kleur-{format}-{handle}-{type}-{code}.jpg */
  function kleurUrl(format, design, type, code) {
    return CDN_KLEUR + 'kh-kleur-' + format + '-' + design + '-' + type + '-' + code.toLowerCase() + '.jpg?v=20260419b';
  }

  /* Shopify option2: '60×60 cm' → '60 x 60 cm' */
  function maatShopify(m) {
    return m.replace('\u00d7', ' x ');
  }

  /* Prijs in centen → '€ 201,75' */
  function formatPrijs(centen) {
    return '\u20ac\u00a0' + (centen / 100).toFixed(2).replace('.', ',');
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Zoek de Shopify-variant op basis van kleur, maat en type.
     Kinderlijn: option1 = 'Kleurnaam (code)', option2 = type, geen maat. */
  function vindVariant(data, kleurCode, maat, type) {
    if (!data) return null;
    var i, v;
    if (isKids()) {
      var kk = KLEUREN[kleurCode];
      if (!kk) return null;
      var optKleur = kk.naam + ' (' + kleurCode + ')';
      for (i = 0; i < data.variants.length; i++) {
        v = data.variants[i];
        if (v.option1 === optKleur && v.option2 === type) return v;
      }
      return null;
    }
    var vk = (KLEUREN[kleurCode] && KLEUREN[kleurCode].variantKleur) || 'Zand';
    var sm = maatShopify(maat);
    for (i = 0; i < data.variants.length; i++) {
      v = data.variants[i];
      if (v.option1 === vk && v.option2 === sm && v.option3 === type) return v;
    }
    return null;
  }

  /* GA4-tracking met stille fallback als gtag niet beschikbaar is */
  function kvTrack(naam, params) {
    if (typeof window.gtag === 'function') window.gtag('event', naam, params || {});
  }

  /* ---------------------------------------------------------
     SVG ICONEN (inline, geen extra request)
  --------------------------------------------------------- */

  var SVG_ZON     = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>';
  var SVG_PALET   = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/><circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/><circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/><circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.555C21.965 6.012 17.461 2 12 2z"/></svg>';
  var SVG_SLUIT_L = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var SVG_SLUIT_S = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var SVG_CART_S  = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.74l1.38-9.26H6"/></svg>';
  var SVG_CART_L  = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.74l1.38-9.26H6"/></svg>';
  var SVG_PENSEEL = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>';
  var SVG_INFO    = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

  /* ---------------------------------------------------------
     HTML OPBOUW
     De trigger-knop wordt in #kv-root geplaatst.
     De overlay wordt aan document.body toegevoegd (fixed).
  --------------------------------------------------------- */

  function bouwHTML(root) {
    var titel = state.titel;

    root.innerHTML =
      '<button id="kv-open-btn" aria-haspopup="dialog">' +
        '<span class="kv-open-btn__icon">' + SVG_PALET + '</span>' +
        '<span class="kv-open-btn__txt">Bekijk dit werk in 50 kleuren</span>' +
      '</button>';

    // Plaats de open-knop als compacte overlay linksonder over de hoofdfoto.
    // (id-binding op regel ~908 via getElementById blijft werken; listeners blijven behouden.)
    var kvMainPhotos = document.querySelector('.product__main-photos');
    var kvOpenBtn = root.querySelector('#kv-open-btn');
    if (kvMainPhotos && kvOpenBtn) {
      kvMainPhotos.appendChild(kvOpenBtn);
      kvMainPhotos.classList.add('kv-has-overlay-btn');
    }

    var overlayEl = document.createElement('div');
    overlayEl.id = 'kv-overlay';
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-modal', 'true');
    overlayEl.setAttribute('aria-label', 'Bekijk kunstwerk in jouw kleur');
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.innerHTML = [
      '<div id="kv-modal">',

        '<div class="kv-modal-header">',
          '<div class="kv-modal-header-rij">',
            '<div>',
              '<div class="kv-modal-sub">' + escHtml(titel) + ' \u00b7 Kleurverkenner</div>',
              '<div class="kv-modal-titel">Bekijk in jouw kleur</div>',
            '</div>',
            '<button id="kv-sluiten" type="button" aria-label="Sluit">' + SVG_SLUIT_L + '</button>',
          '</div>',
          '<div class="kv-muur-sectie kv-muur-sectie--header">',
            '<div class="kv-muur-links">',
              '<span class="kv-muur-lbl">Muurkleur</span>',
              '<div class="kv-muur-controls">',
                '<div id="kv-presets"></div>',
                '<div class="kv-muur-picker-wrap" title="Eigen kleur kiezen">',
                  SVG_PENSEEL,
                  '<input type="color" class="kv-muur-picker" id="kv-muur-picker" value="#F5F0E8" aria-label="Eigen muurkleur">',
                '</div>',
              '</div>',
            '</div>',
            '<button id="kv-bestel-open-btn" type="button" aria-expanded="false">' + SVG_CART_S + 'Bestellen</button>',
          '</div>',
        '</div>',

        '<div class="kv-modal-body">',
          '<div class="kv-viewer kv-viewer--single" id="kv-viewer" style="background-color:#F5F0E8">',
            '<div class="kv-beeld-area" id="kv-beeld-area">',
              '<img class="kv-beeld" id="kv-beeld-1" src="" alt="">',
            '</div>',
            '<div class="kv-loader" id="kv-loader"><div class="kv-spinner"></div></div>',
          '</div>',

          '<div class="kv-onder-viewer">',
            '<div class="kv-type-knoppen" role="group" aria-label="Uitvoering">',
              '<button class="kv-type-btn actief" type="button" data-modus="inliggend">Inliggend</button>',
              '<button class="kv-type-btn" type="button" data-modus="opliggend">Opliggend</button>',
              /* Kinderlijn kent geen twin-variant */
              (isKids() ? '' : '<button class="kv-type-btn" type="button" data-modus="twin">Twin</button>'),
            '</div>',
            '<div class="kv-kleur-info" id="kv-kleur-info">',
              '<div class="kv-kleur-dot"><img id="kv-kleur-dot-img" src="" alt="" loading="lazy"></div>',
              '<span class="kv-kleur-naam" id="kv-kleur-naam">\u2014</span>',
              '<span class="kv-kleur-code" id="kv-kleur-code"></span>',
            '</div>',
            '<div id="kv-maatwerk-melding" style="display:none">' + SVG_INFO + 'Op maat gemaakt in deze kleur. Retourneren is niet mogelijk.</div>',
            '<div class="kv-swatches-label">Kies jouw kleur</div>',
            '<div class="kv-swatches" id="kv-swatches" role="list"></div>',
            '<button id="kv-meer-kleuren" type="button" aria-expanded="false">Meer kleuren tonen \u2192</button>',
          '</div>',
        '</div>',

        '<div class="kv-bestel-panel" id="kv-bestel-panel" aria-hidden="true">',
          '<div class="kv-bestel-inner">',
            '<div class="kv-bestel-topbar">',
              '<div>',
                '<div class="kv-bestel-sectielbl">Bestellen</div>',
                '<div class="kv-bestel-samenvatting">',
                  '<span id="kv-bestel-product">' + escHtml(titel) + '</span> \u00b7 ',
                  '<span id="kv-bestel-kleurwaarde">\u2014</span> \u00b7 ',
                  '<span id="kv-bestel-uitvoering">\u2014</span>',
                '</div>',
              '</div>',
              '<button id="kv-bestel-sluit" type="button" aria-label="Sluit">' + SVG_SLUIT_S + '</button>',
            '</div>',
            '<div class="kv-bestel-afmeting-lbl">Afmeting</div>',
            '<div class="kv-bestel-maten" id="kv-bestel-maten"></div>',
            '<div class="kv-bestel-onderrij">',
              '<div class="kv-bestel-prijs" id="kv-bestel-prijs">\u2014</div>',
              '<button type="button" class="kv-bestel-cart" id="kv-bestel-cart" disabled>' + SVG_CART_L + 'In winkelmand</button>',
            '</div>',
          '</div>',
        '</div>',

      '</div>',
      '<div class="kv-tooltip" id="kv-tooltip" aria-hidden="true"></div>'
    ].join('');

    document.body.appendChild(overlayEl);
  }

  /* ---------------------------------------------------------
     MODAL OPEN / SLUIT
  --------------------------------------------------------- */

  var kvScrollY      = 0;
  var kvVerborgenEls = [];

  /*
   * Verberg UI-elementen die over de modal heen vallen:
   *   - Keuzehulp sidetab (#kh-side-tab)
   *   - Petterns sticky add-to-cart knop (.sticky-button)
   */
  function verbergUiEls() {
    kvVerborgenEls = [];

    ['#kh-side-tab', '.sticky-button'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) { el.style.setProperty('display', 'none', 'important'); kvVerborgenEls.push(el); }
    });
  }

  function herstelUiEls() {
    kvVerborgenEls.forEach(function (el) { el.style.removeProperty('display'); });
    kvVerborgenEls = [];
  }

  /*
   * iOS Safari: 100vh verandert mee met de adresbalk (verdwijnen/verschijnen).
   * Bij openen zetten we de hoogte eenmalig op window.innerHeight zodat de
   * modal niet opschuift als de adresbalk later verdwijnt.
   */
  function fixModalHoogte() {
    var modal = document.getElementById('kv-modal');
    if (!modal || window.innerWidth > 760) return;
    modal.style.height = (window.innerHeight - 60) + 'px';
  }

  function openModal() {
    var overlay = document.getElementById('kv-overlay');
    if (!overlay) return;
    modalOpen = true;
    verbergUiEls();
    fixModalHoogte();
    /* iOS body-freeze: voorkomt dat de pagina scrollt onder de modal */
    kvScrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + kvScrollY + 'px';
    document.body.style.width    = '100%';
    document.body.style.overflow = 'hidden';
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    kvTrack('kv_modal_open', { kv_product: state.handle });
    if (eersteBeeldLaad) { eersteBeeldLaad = false; laadAfbeelding(); }
  }

  function sluitModal() {
    var overlay = document.getElementById('kv-overlay');
    if (!overlay) return;
    modalOpen = false;
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    document.body.style.overflow = '';
    window.scrollTo(0, kvScrollY);
    herstelUiEls();
    sluitBestelPanel();
  }

  /* ---------------------------------------------------------
     VIEWER — wisselt tussen single en twin layout
  --------------------------------------------------------- */

  function herbouwViewer() {
    if (!elViewer || !elBeeldArea) return;
    elViewer.style.backgroundColor = state.muurkleur;
    if (state.modus === 'twin') {
      elViewer.className = 'kv-viewer kv-viewer--twin';
      elBeeldArea.innerHTML = [
        '<div class="kv-beeld-col">',
          '<img class="kv-beeld" id="kv-beeld-inliggend" src="" alt="Inliggend">',
          '<span class="kv-type-label">Inliggend</span>',
        '</div>',
        '<div class="kv-beeld-col">',
          '<img class="kv-beeld" id="kv-beeld-opliggend" src="" alt="Opliggend">',
          '<span class="kv-type-label">Opliggend</span>',
        '</div>'
      ].join('');
    } else {
      elViewer.className = 'kv-viewer kv-viewer--single';
      elBeeldArea.innerHTML = '<img class="kv-beeld" id="kv-beeld-1" src="" alt="">';
    }
  }

  /* ---------------------------------------------------------
     AFBEELDINGEN LADEN
     Preload via Image()-object zodat de swap pas plaatsvindt
     als de afbeelding volledig geladen is (geen flicker).
  --------------------------------------------------------- */

  function laadAfbeelding() {
    if (state.modus === 'twin') { laadTwin(); return; }
    var img = document.getElementById('kv-beeld-1');
    if (!img) return;
    var url = kleurUrl(state.format, state.handle, state.modus, state.kleur);
    img.classList.add('laden');
    if (elLoader) elLoader.classList.add('actief');
    var p = new Image();
    p.onload  = function () { img.src = url; img.classList.remove('laden'); if (elLoader) elLoader.classList.remove('actief'); };
    p.onerror = function () {                img.classList.remove('laden'); if (elLoader) elLoader.classList.remove('actief'); };
    p.src = url;
  }

  function laadTwin() {
    var imgIn = document.getElementById('kv-beeld-inliggend');
    var imgOp = document.getElementById('kv-beeld-opliggend');
    if (!imgIn || !imgOp) return;
    if (elLoader) elLoader.classList.add('actief');
    var geladen = 0;
    function check() { if (++geladen === 2 && elLoader) elLoader.classList.remove('actief'); }
    [{el: imgIn, type: 'inliggend'}, {el: imgOp, type: 'opliggend'}].forEach(function (item) {
      item.el.classList.add('laden');
      var url = kleurUrl(state.format, state.handle, item.type, state.kleur);
      var p = new Image();
      p.onload  = function () { item.el.src = url; item.el.classList.remove('laden'); check(); };
      p.onerror = function () {               item.el.classList.remove('laden'); check(); };
      p.src = url;
    });
  }

  /* ---------------------------------------------------------
     STATE SETTERS
  --------------------------------------------------------- */

  function setKleur(code) {
    state.kleur = code;
    laadAfbeelding();
    updateKleurInfo();
    document.querySelectorAll('.kv-swatch').forEach(function (s) {
      s.classList.toggle('actief', s.dataset.code === code);
    });
    updateBestelSamenvatting();
    updateVariantPrijs();
    kvTrack('kv_kleur_select', { kv_product: state.handle, kv_kleur: code, kv_naam: KLEUREN[code] ? KLEUREN[code].naam : '' });
  }

  function setModus(modus) {
    state.modus = modus;
    document.querySelectorAll('.kv-type-btn').forEach(function (b) {
      b.classList.toggle('actief', b.dataset.modus === modus);
    });
    herbouwViewer();
    laadAfbeelding();
    updateBestelSamenvatting();
    updateVariantPrijs();
    kvTrack('kv_modus_select', { kv_product: state.handle, kv_modus: modus });
  }

  function setMuurkleur(hex) {
    state.muurkleur = hex;
    if (elViewer) elViewer.style.backgroundColor = hex;
    document.querySelectorAll('.kv-preset').forEach(function (b) {
      b.classList.toggle('actief', b.dataset.hex === hex);
    });
    kvTrack('kv_muurkleur_select', { kv_product: state.handle, kv_muurkleur: hex });
  }

  /* ---------------------------------------------------------
     UI UPDATES
  --------------------------------------------------------- */

  function updateKleurInfo() {
    var k  = KLEUREN[state.kleur];
    if (!k) return;
    var di = document.getElementById('kv-kleur-dot-img');
    var kn = document.getElementById('kv-kleur-naam');
    var kc = document.getElementById('kv-kleur-code');
    if (di) di.src = k.img;
    if (kn) kn.textContent = k.naam;
    if (kc) kc.textContent = '(' + state.kleur.replace('_NL', '') + ')';
    /* Kinderlijn: elke kleur is een gewone variant — geen maatwerk-melding */
    var melding = document.getElementById('kv-maatwerk-melding');
    if (melding) melding.style.display = (k.gpoWaarde && !isKids()) ? '' : 'none';
  }

  function updateBestelSamenvatting() {
    var k = KLEUREN[state.kleur];
    var modusLabel = { inliggend:'Inliggend', opliggend:'Opliggend', twin:'Twin Set' }[state.modus] || '\u2014';
    var el = document.getElementById('kv-bestel-kleurwaarde');
    var eu = document.getElementById('kv-bestel-uitvoering');
    if (el) el.textContent = k ? k.naam : '\u2014';
    if (eu) eu.textContent = modusLabel;
  }

  function updateVariantPrijs() {
    if (!state.maat) return;
    var v       = vindVariant(state.productData, state.kleur, state.maat, TYPE_SHOPIFY[state.modus]);
    var prijsEl = document.getElementById('kv-bestel-prijs');
    var cartBtn = document.getElementById('kv-bestel-cart');
    if (v) {
      state.variantId = v.id;
      if (prijsEl) prijsEl.textContent = formatPrijs(v.price);
      if (cartBtn) { cartBtn.classList.add('klaar'); cartBtn.disabled = false; }
    } else {
      state.variantId = null;
      if (prijsEl) prijsEl.textContent = '\u2014';
      if (cartBtn) { cartBtn.classList.remove('klaar'); cartBtn.disabled = true; }
    }
  }

  /* ---------------------------------------------------------
     MUURKLEUR PRESETS VULLEN
  --------------------------------------------------------- */

  function vulPresets() {
    var wrap = document.getElementById('kv-presets');
    if (!wrap) return;
    MUURKLEUREN_PRESETS.forEach(function (p) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kv-preset' + (p.hex === state.muurkleur ? ' actief' : '');
      btn.style.backgroundColor = p.hex;
      btn.title = p.naam;
      btn.dataset.hex = p.hex;
      btn.setAttribute('aria-label', p.naam);
      btn.addEventListener('click', function () {
        setMuurkleur(p.hex);
        var picker = document.getElementById('kv-muur-picker');
        if (picker) picker.value = p.hex;
      });
      wrap.appendChild(btn);
    });
  }

  /* ---------------------------------------------------------
     KLEUR-SWATCHES VULLEN
  --------------------------------------------------------- */

  function vulSwatches() {
    var wrap = document.getElementById('kv-swatches');
    if (!wrap) return;
    KLEUREN_VOLGORDE.forEach(function (code) {
      var k = KLEUREN[code];
      if (!k) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kv-swatch' + (code === state.kleur ? ' actief' : '');
      btn.dataset.code = code;
      btn.setAttribute('role', 'listitem');
      btn.setAttribute('aria-label', k.naam);
      var img = document.createElement('img');
      img.src = k.img;
      img.alt = k.naam;
      img.loading = 'lazy';
      btn.appendChild(img);
      btn.addEventListener('click', function () { setKleur(code); });
      btn.addEventListener('mouseenter', function (e) { toonTooltip(e, k.naam); });
      btn.addEventListener('mouseleave', verbergTooltip);
      wrap.appendChild(btn);
    });
  }

  /* ---------------------------------------------------------
     TOOLTIP
  --------------------------------------------------------- */

  function toonTooltip(e, tekst) {
    if (!elTooltip) return;
    elTooltip.textContent = tekst;
    elTooltip.style.left  = e.clientX + 'px';
    elTooltip.style.top   = e.clientY + 'px';
    elTooltip.classList.add('zichtbaar');
  }

  function verbergTooltip() {
    if (elTooltip) elTooltip.classList.remove('zichtbaar');
  }

  /* ---------------------------------------------------------
     BESTEL PANEL
  --------------------------------------------------------- */

  function openBestelPanel() {
    /* Kinderlijn heeft één vaste maat — direct voorselecteren */
    state.maat      = isKids() ? KIDS_MAAT : null;
    state.variantId = null;
    vulBestelMaten();
    updateBestelSamenvatting();
    var prijsEl = document.getElementById('kv-bestel-prijs');
    var cartBtn = document.getElementById('kv-bestel-cart');
    if (prijsEl) prijsEl.textContent = '\u2014';
    if (cartBtn) { cartBtn.classList.remove('klaar'); cartBtn.disabled = true; cartBtn.innerHTML = SVG_CART_L + 'In winkelmand'; }
    var panel   = document.getElementById('kv-bestel-panel');
    var openBtn = document.getElementById('kv-bestel-open-btn');
    if (panel)   { panel.classList.add('open'); panel.setAttribute('aria-hidden', 'false'); }
    if (openBtn) { openBtn.classList.add('actief'); openBtn.setAttribute('aria-expanded', 'true'); }
    kvTrack('kv_bestel_open', { kv_product: state.handle, kv_kleur: state.kleur, kv_modus: state.modus });
    /* Product-data lazy laden voor prijsbepaling */
    laadProduct(function (data) { if (data) updateVariantPrijs(); });
  }

  function sluitBestelPanel() {
    var panel   = document.getElementById('kv-bestel-panel');
    var openBtn = document.getElementById('kv-bestel-open-btn');
    if (panel)   { panel.classList.remove('open'); panel.setAttribute('aria-hidden', 'true'); }
    if (openBtn) { openBtn.classList.remove('actief'); openBtn.setAttribute('aria-expanded', 'false'); }
  }

  function vulBestelMaten() {
    var wrap = document.getElementById('kv-bestel-maten');
    if (!wrap) return;
    wrap.innerHTML = '';
    /* Kinderlijn: één maat, meteen actief */
    var maten = isKids()
      ? [{ maat: KIDS_MAAT, naam: 'Eén maat' }]
      : (AFMETINGEN[state.format] || []);
    maten.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kv-bestel-maat' + (item.maat === state.maat ? ' actief' : '');
      btn.innerHTML =
        '<span class="kv-bestel-maat-naam">' + escHtml(item.naam) + '</span>' +
        '<span class="kv-bestel-maat-label">' + escHtml(item.maat) + '</span>';
      btn.addEventListener('click', function () {
        state.maat = item.maat;
        wrap.querySelectorAll('.kv-bestel-maat').forEach(function (b) {
          var lbl = b.querySelector('.kv-bestel-maat-label');
          b.classList.toggle('actief', lbl && lbl.textContent === item.maat);
        });
        updateVariantPrijs();
        kvTrack('kv_maat_select', { kv_product: state.handle, kv_maat: item.maat });
      });
      wrap.appendChild(btn);
    });
  }

  /* ---------------------------------------------------------
     PRODUCT DATA — lazy fetch, gecached in state.productData
  --------------------------------------------------------- */

  function laadProduct(cb) {
    if (state.productData) { cb(state.productData); return; }
    fetch('/products/' + state.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { state.productData = d; cb(d); })
      .catch(function () { cb(null); });
  }

  /* ---------------------------------------------------------
     WINKELMAND
     ajaxProduct:added triggert de theme's CartDrawer.buildCart()
     die de drawer vult én opent (standaard theme-gedrag).
  --------------------------------------------------------- */

  function verversWinkelmand() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  function voegToeAanWinkelmand() {
    if (!state.variantId) return;
    var cartBtn = document.getElementById('kv-bestel-cart');
    if (cartBtn) { cartBtn.disabled = true; cartBtn.innerHTML = SVG_CART_L + 'Toevoegen\u2026'; }

    var k          = KLEUREN[state.kleur];
    var properties = {};
    /* GPO (Gepersonaliseerd Product Onderdeel) vereist voor maatwerk-kleurvarianten.
       Kinderlijn: elke kleur is een eigen variant — geen GPO nodig. */
    if (k && k.gpoWaarde && !isKids()) properties['Maatwerk kleur'] = k.gpoWaarde;

    kvTrack('kv_add_to_cart', { kv_product: state.handle, kv_kleur: k ? k.naam : '', kv_maat: state.maat, kv_modus: state.modus });

    var afgerond  = false;
    var timeoutId = setTimeout(function () { klaar(false); }, 10000);

    function klaar(succes) {
      if (afgerond) return;
      afgerond = true;
      clearTimeout(timeoutId);
      if (succes) {
        kvTrack('kv_besteld', { kv_product: state.handle, kv_kleur: k ? k.naam : '', kv_maat: state.maat, kv_modus: state.modus });
        if (cartBtn) { cartBtn.disabled = false; cartBtn.innerHTML = SVG_CART_L + 'Toegevoegd \u2713'; }
        setTimeout(function () {
          sluitBestelPanel();
          if (cartBtn) { cartBtn.innerHTML = SVG_CART_L + 'In winkelmand'; }
        }, 1200);
      } else {
        if (cartBtn) { cartBtn.disabled = false; cartBtn.innerHTML = SVG_CART_L + 'In winkelmand'; }
      }
    }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: [{ id: state.variantId, quantity: 1, properties: properties }] })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error('HTTP ' + r.status); });
      return r.json();
    })
    .then(function () { klaar(true); verversWinkelmand(); })
    .catch(function () { klaar(false); });
  }

  /* ---------------------------------------------------------
     INIT
  --------------------------------------------------------- */

  /* ---------------------------------------------------------
     PUBLIEKE API
     De kleurengalerij (sections/kleurengalerij.liquid) hergebruikt deze
     tabellen, zodat de 50 kleuren op een plek staan en niet uit elkaar lopen.
  --------------------------------------------------------- */
  window.PetternsKleuren = {
    KLEUREN:     KLEUREN,
    FORMAT_MAP:  FORMAT_MAP,
    KIDS_HANDLES: typeof KIDS_HANDLES !== 'undefined' ? KIDS_HANDLES : [],
    kleurUrl:    kleurUrl,
    /* '463_nl' en '463_NL' en '17' verwijzen naar dezelfde kleur */
    normaliseer: function (code) {
      if (!code) return null;
      var c = String(code).trim().replace(/_nl$/i, '_NL');
      if (/^[0-9]$/.test(c)) c = '0' + c;
      return KLEUREN[c] ? c : null;
    }
  };

  function init() {
    var root = document.getElementById('kv-root');
    if (!root) return;

    var handle = root.dataset.handle;
    if (!handle || !FORMAT_MAP[handle]) return;

    state.handle = handle;
    state.titel  = root.dataset.titel || '';
    state.format = FORMAT_MAP[handle];

    bouwHTML(root);
    vulPresets();
    vulSwatches();
    updateKleurInfo();

    /* DOM-refs cachen na opbouw */
    elViewer   = document.getElementById('kv-viewer');
    elBeeldArea = document.getElementById('kv-beeld-area');
    elLoader   = document.getElementById('kv-loader');
    elTooltip  = document.getElementById('kv-tooltip');

    /* Trigger-knop in #kv-root */
    document.getElementById('kv-open-btn').addEventListener('click', openModal);

    /* Extra trigger-knoppen op de pagina ({% render 'kleurverkenner-knop' %}) */
    document.querySelectorAll('[data-kv-trigger]').forEach(function (el) {
      el.addEventListener('click', openModal);
    });

    /* Modal controls */
    document.getElementById('kv-sluiten').addEventListener('click', sluitModal);
    document.getElementById('kv-overlay').addEventListener('click', function (e) {
      if (e.target === this) sluitModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalOpen) sluitModal();
    });

    /* Type-knoppen via delegatie op de modal */
    document.getElementById('kv-modal').addEventListener('click', function (e) {
      var btn = e.target.closest('.kv-type-btn');
      if (btn && btn.dataset.modus) setModus(btn.dataset.modus);
    });

    /* Muurkleur-picker */
    document.getElementById('kv-muur-picker').addEventListener('input', function () {
      setMuurkleur(this.value);
      document.querySelectorAll('.kv-preset').forEach(function (b) { b.classList.remove('actief'); });
    });

    /* Meer/minder kleuren */
    document.getElementById('kv-meer-kleuren').addEventListener('click', function () {
      var s    = document.getElementById('kv-swatches');
      var open = s.classList.toggle('uitgevouwen');
      this.textContent = open ? 'Minder kleuren \u2191' : 'Meer kleuren tonen \u2192';
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* Bestel panel */
    document.getElementById('kv-bestel-open-btn').addEventListener('click', function () {
      var panel = document.getElementById('kv-bestel-panel');
      panel.classList.contains('open') ? sluitBestelPanel() : openBestelPanel();
    });
    document.getElementById('kv-bestel-sluit').addEventListener('click', sluitBestelPanel);
    document.getElementById('kv-bestel-cart').addEventListener('click', voegToeAanWinkelmand);

    /* Diepe link vanuit de kleurengalerij-mail: ?kv=<code> opent de verkenner
       meteen in die kleur. Zonder dit landt de klant op het standaard witte
       product en klopt de belofte uit de mail niet. */
    var kvCode = window.PetternsKleuren.normaliseer(
      new URLSearchParams(window.location.search).get('kv')
    );
    if (kvCode) {
      setKleur(kvCode);
      openModal();
    }

    /* Tooltip volgt de muis — alleen actief als modal open is */
    document.addEventListener('mousemove', function (e) {
      if (!modalOpen || !elTooltip || !elTooltip.classList.contains('zichtbaar')) return;
      elTooltip.style.left = e.clientX + 'px';
      elTooltip.style.top  = e.clientY + 'px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
